export const SYSTEM_CMS_PAGE_SLUGS = [
  'about',
  'privacy-policy',
  'terms',
  'cookie-policy',
  'shipping-delivery-policy',
  'return-exchange-policy',
  'return-refund-policy',
] as const;

/** @deprecated Prefer SYSTEM_CMS_PAGE_SLUGS — custom pages use any slug. */
export const CMS_PAGE_SLUGS = SYSTEM_CMS_PAGE_SLUGS;

export type SystemCmsPageSlug = (typeof SYSTEM_CMS_PAGE_SLUGS)[number];
export type CmsPageSlug = string;

export const SYSTEM_CMS_PAGE_LABELS: Record<SystemCmsPageSlug, string> = {
  about: 'About Us',
  'privacy-policy': 'Privacy Policy',
  terms: 'Terms & Conditions',
  'cookie-policy': 'Cookie Policy',
  'shipping-delivery-policy': 'Shipping & Delivery Policy',
  'return-exchange-policy': 'Return & Exchange Policy',
  'return-refund-policy': 'Return & Refund Policy',
};

/** @deprecated Prefer SYSTEM_CMS_PAGE_LABELS */
export const CMS_PAGE_LABELS = SYSTEM_CMS_PAGE_LABELS;

export function isSystemCmsSlug(slug: string): boolean {
  return (SYSTEM_CMS_PAGE_SLUGS as readonly string[]).includes(slug);
}

export function cmsPageLabel(slug: string, title?: string): string {
  if (isSystemCmsSlug(slug)) {
    return SYSTEM_CMS_PAGE_LABELS[slug as SystemCmsPageSlug];
  }
  return title?.trim() || slug;
}

/** Public storefront path for a CMS slug. */
export function cmsPublicPath(slug: string): string {
  switch (slug) {
    case 'about':
      return '/about';
    case 'privacy-policy':
      return '/privacy-policy';
    case 'cookie-policy':
      return '/cookie-policy';
    case 'terms':
      return '/TermsDisclaimer';
    case 'shipping-delivery-policy':
      return '/shipping-delivery-policy';
    case 'return-exchange-policy':
      return '/return-exchange-policy';
    case 'return-refund-policy':
      return '/return-refund-policy';
    default:
      return `/page/${encodeURIComponent(slug)}`;
  }
}

export interface CmsPage {
  id: string;
  slug: string;
  title: string;
  content: string;
  seoTitle: string;
  seoDescription: string;
  metaKeywords: string;
  isPublished: boolean;
  isSystem?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CmsPagesResponse {
  results: CmsPage[];
}

export interface UpdateCmsPagePayload {
  title?: string;
  content?: string;
  seoTitle?: string;
  seoDescription?: string;
  metaKeywords?: string;
  isPublished?: boolean;
}

export interface CreateCmsPagePayload {
  slug: string;
  title: string;
  content?: string;
  seoTitle?: string;
  seoDescription?: string;
  metaKeywords?: string;
  isPublished?: boolean;
}
